{
    "finra-exception-quick-search-fields": [
        {
            "label": "Status", "columnname": "modifiedFlag", "placeholder": "Status",
            "width": "", "datatype": "Array", "isLarge": false
        },
        {
            "label": "FirmROEID", "columnname": "firmROEID", "placeholder": "FirmROEID",
            "width": "", "datatype": "String", "isLarge": true
        },
        {
            "label": "EventType", "columnname": "type", "placeholder": "EventType",
            "width": "", "datatype": "Array", "isLarge": false, "preserveUserOptedValues": true
        },
        {
            "label": "Symbol", "columnname": "symbol", "placeholder": "Symbol",
            "width": "", "datatype": "String", "isLarge": false
        },
        {
            "label": "OrderID", "columnname": "orderID", "placeholder": "OrderID",
            "width": "", "datatype": "String", "isLarge": true
        },
        {
            "label": "FirmDesignatedID", "columnname": "firmDesignatedID", "placeholder": "FirmDesignatedID",
            "width": "", "datatype": "String", "isLarge": true
        },
        {
            "label": "Destination", "columnname": "destination", "placeholder": "Destination",
            "width": "", "datatype": "String", "isLarge": false
        },
        {
            "label": "RoutedOrderID", "columnname": "routedOrderID", "placeholder": "RoutedOrderID",
            "width": "", "datatype": "String", "isLarge": true
        },
        {
            "label": "SenderIMID", "columnname": "senderIMID", "placeholder": "SenderIMID",
            "width": "", "datatype": "String", "isLarge": false
        }
      ],
    "finra-exception-grid-columns": [
        {
            "display": "true",
            "ui_columnname": "action",
            "db_columnname": "modifiedFlag",
            "datatype": "char",
            "mappingkey": "modifiedFlag",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "true",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Error ROE ID",
            "db_columnname": "errorROEID",
            "datatype": "String",
            "mappingkey": "errorROEID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "firm ROE ID",
            "db_columnname": "firmROEID",
            "datatype": "String",
            "mappingkey": "firmROEID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        
        {
            "display": "true",
            "ui_columnname": "order ID",
            "db_columnname": "orderID",
            "datatype": "String",
            "mappingkey": "orderID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "order Date",
            "db_columnname": "orderKeyDate",
            "datatype": "String",
            "mappingkey": "orderKeyDate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "symbol",
            "db_columnname": "symbol",
            "datatype": "String",
            "mappingkey": "symbol",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "type",
            "db_columnname": "type",
            "datatype": "String",
            "mappingkey": "type",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Date",
            "db_columnname": "reportDate",
            "datatype": "Date",
            "mappingkey": "reportDate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Failure Code",
            "db_columnname": "failureCode",
            "datatype": "String",
            "mappingkey": "failureCode",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Failure Description",
            "db_columnname": "failureDescription",
            "datatype": "String",
            "mappingkey": "failureDescription",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Comments",
            "db_columnname": "caseComments",
            "datatype": "String",
            "mappingkey": "caseComments",
            "dropdown": "NO",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Side",
            "db_columnname": "side",
            "datatype": "String",
            "mappingkey": "side",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Price",
            "db_columnname": "price",
            "datatype": "Float",
            "mappingkey": "price",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Quantity",
            "db_columnname": "quantity",
            "datatype": "Int",
            "mappingkey": "quantity",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "destination",
            "db_columnname": "destination",
            "datatype": "String",
            "mappingkey": "destination",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "routed Order ID",
            "db_columnname": "routedOrderID",
            "datatype": "String",
            "mappingkey": "routedOrderID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Parent Order ID",
            "db_columnname": "parentOrderID",
            "datatype": "String",
            "mappingkey": "parentOrderID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Parent Order Date",
            "db_columnname": "parentOrderKeyDate",
            "datatype": "String",
            "mappingkey": "parentOrderKeyDate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "FirmDesignatedID",
            "db_columnname": "firmDesignatedID",
            "datatype": "String",
            "mappingkey": "firmDesignatedID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Actual Value",
            "db_columnname": "actualValue",
            "datatype": "String",
            "mappingkey": "actualValue",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Suggested Value",
            "db_columnname": "suggestedValue",
            "datatype": "String",
            "mappingkey": "suggestedValue",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Actual ID 1",
            "db_columnname": "actualID_1",
            "datatype": "String",
            "mappingkey": "actualID_1",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Actual KeyDate 1",
            "db_columnname": "actualKeyDate_1",
            "datatype": "String",
            "mappingkey": "actualKeyDate_1",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Actual ID 2",
            "db_columnname": "actualID_2",
            "datatype": "String",
            "mappingkey": "actualID_2",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Actual KeyDate 2",
            "db_columnname": "actualKeyDate_2",
            "datatype": "String",
            "mappingkey": "actualKeyDate_2",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Allocation ID",
            "db_columnname": "allocationID",
            "datatype": "String",
            "mappingkey": "allocationID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "RepresentativeInd",
            "db_columnname": "representativeInd",
            "datatype": "String",
            "mappingkey": "representativeInd",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "RouteRejectedFlag",
            "db_columnname": "routeRejectedFlag",
            "datatype": "Boolean",
            "mappingkey": "routeRejectedFlag",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "SolicitationFlag",
            "db_columnname": "solicitationFlag",
            "datatype": "Boolean",
            "mappingkey": "solicitationFlag",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "false",
            "ui_columnname": "Session",
            "db_columnname": "session",
            "datatype": "String",
            "mappingkey": "session",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Trade Id",
            "db_columnname": "tradeID",
            "datatype": "String",
            "mappingkey": "tradeID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Quote Id",
            "db_columnname": "quoteID",
            "datatype": "String",
            "mappingkey": "quoteID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Quote MPID",
            "db_columnname": "quoteMPID",
            "datatype": "String",
            "mappingkey": "quoteMPID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Event Timestamp",
            "db_columnname": "eventTimestamp",
            "datatype": "String",
            "mappingkey": "eventTimestamp",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Manual Flag",
            "db_columnname": "manualFlag",
            "datatype": "Boolean",
            "mappingkey": "manualFlag",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Time In Force",
            "db_columnname": "timeInForce",
            "datatype": "String",
            "mappingkey": "timeInForce",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Sender IMID",
            "db_columnname": "senderIMID",
            "datatype": "String",
            "mappingkey": "senderIMID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Handlling Instructions",
            "db_columnname": "handlingInstructions",
            "datatype": "String",
            "mappingkey": "handlingInstructions",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "SideDetailsInd",
            "db_columnname": "sideDetailsInd",
            "datatype": "String",
            "mappingkey": "sideDetailsInd",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "ElectronicTimestamp",
            "db_columnname": "electronicTimestamp",
            "datatype": "String",
            "mappingkey": "electronicTimestamp",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "false",
            "ui_columnname": "Severity",
            "db_columnname": "severity",
            "datatype": "String",
            "mappingkey": "severity",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "CAT Submitter ID",
            "db_columnname": "catSubmitterID",
            "datatype": "String",
            "mappingkey": "catSubmitterID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "CAT Reporter ID",
            "db_columnname": "catReporterIMID",
            "datatype": "String",
            "mappingkey": "catReporterIMID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        
        {
            "display": "true",
            "ui_columnname": "Group",
            "db_columnname": "groupName",
            "datatype": "String",
            "mappingkey": "groupName",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "File Name",
            "db_columnname": "fileName",
            "datatype": "String",
            "mappingkey": "fileName",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Status",
            "db_columnname": "status",
            "datatype": "String",
            "mappingkey": "status",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "BuyOrderID",
            "db_columnname": "buyOrderID",
            "datatype": "String",
            "mappingkey": "buyOrderID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "SellOrderID",
            "db_columnname": "sellOrderID",
            "datatype": "String",
            "mappingkey": "sellOrderID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "ClientOrderID",
            "db_columnname": "clientOrderID",
            "datatype": "String",
            "mappingkey": "clientOrderID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "FirmOrderID",
            "db_columnname": "firmOrderID",
            "datatype": "String",
            "mappingkey": "firmOrderID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Action Type",
            "db_columnname": "actionType",
            "datatype": "String",
            "mappingkey": "actionType",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "BFMMFlag",
            "db_columnname": "bfmmFlag",
            "datatype": "Boolean",
            "mappingkey": "bfmmFlag",
            "dropdown": "NO",
            "isdefault":  "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "create Date",
            "db_columnname": "createDate",
            "datatype": "String",
            "mappingkey": "createDate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "last Update",
            "db_columnname": "lastUpdate",
            "datatype": "String",
            "mappingkey": "lastUpdate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "user",
            "db_columnname": "user",
            "datatype": "String",
            "mappingkey": "user",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        }
    ]
}